import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import { baseUrl } from "../../helper/urls.js";
import { useSelector } from "react-redux";

const RegisterStudent = () => {
  const { token } = useSelector((state) => state.auth);
  const url = `${baseUrl}/api/students`;
  const location = useLocation();
  const studentData = location.state?.student;
  // console.log("students::::::::::::::::::::", !!studentData);
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    schoolName: "",
    currentGrade: "",
  });

  useEffect(() => {
    if (studentData) {
      setFormData(studentData);
    }
  }, [studentData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const headers = {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: `Bearer ${token}`,
    };

    try {
      let response;

      if (studentData?.id) {
        const updatePayload = {
          firstName: formData.firstName,
          lastName: formData.lastName,
          schoolName: formData.schoolName,
          currentGrade: formData.currentGrade,
          email: formData.email,
          phone: formData.phone,
        };
        // update
        response = await axios.put(`${url}/${studentData.id}`, updatePayload, {
          headers,
        });
        console.log(
          "response33333333333333333333:::::",
          response.data.data.message
        );
      } else {
        // CREATE
        response = await axios.post(url, formData, { headers });
      }

      if (response.status === 200) {
        toast.success(
          response.data.data.message || "Student saved successfully!"
        );
        navigate("/student-login");
        // navigate("/all-students");
      }
    } catch (error) {
      error.response.data.errors &&
        error.response.data.errors?.map((error) => {
          toast.error(error.msg);
          console.error(error.msg);
        });
      console.error("Error submitting student:", error);
    }
  };

  return (
    <>
      <ToastContainer position="top-right" autoClose={3000} />

      <div className="card h-100 p-0 mt-300  ">
        <div
        //   className="card p-12 radius-20"
        //   style={{ width: "100%", maxWidth: "1500px" }}
        >
          {/* <div className="card p-4 radius-12" style={{ width: "100%", maxWidth: "900px" }}> */}
          <div className="row justify-content-center ">
            <div className="col-12">
              <div
                className="card"
                style={{
                  backgroundColor: "F5F6FA",
                  boxShadow: "none",
                }}
              >
                <div
                  className="card-body px-200 pt-100 pb-600 "
                  style={{
                    marginTop: "150px",
                    marginButtom: "150px",
                  }}
                >
                  <h6 className="text-center">Student</h6>

                  <form onSubmit={handleSubmit}>
                    <div className="row">
                      <div className="col-sm-6 mb-3">
                        <label htmlFor="firstName" className="form-label">
                          First Name <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control radius-8"
                          id="firstName"
                          name="firstName"
                          placeholder="Enter First Name"
                          value={formData.firstName}
                          onChange={handleChange}
                          required
                        />
                      </div>

                      <div className="col-sm-6 mb-3">
                        <label htmlFor="lastName" className="form-label">
                          Last Name <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control radius-8"
                          id="lastName"
                          name="lastName"
                          placeholder="Enter Last Name"
                          value={formData.lastName}
                          onChange={handleChange}
                          required
                        />
                      </div>

                      <div className="col-sm-6 mb-3">
                        <label htmlFor="email" className="form-label">
                          Email <span className="text-danger">*</span>
                        </label>
                        <input
                          type="email"
                          className="form-control radius-8"
                          id="email"
                          name="email"
                          placeholder="Enter Email"
                          value={formData.email}
                          onChange={handleChange}
                          required
                          disabled={!!studentData}
                        />
                      </div>

                      <div className="col-sm-6 mb-3">
                        <label htmlFor="phone" className="form-label">
                          Phone <span className="text-danger">*</span>
                        </label>
                        <input
                          type="tel"
                          className="form-control radius-8"
                          id="phone"
                          name="phone"
                          placeholder="Enter Phone Number"
                          value={formData.phone}
                          onChange={handleChange}
                          required
                          disabled={!!studentData}
                        />
                      </div>

                      <div className="col-sm-6 mb-3">
                        <label htmlFor="schoolName" className="form-label">
                          School Name <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control radius-8"
                          id="schoolName"
                          name="schoolName"
                          placeholder="Enter School Name"
                          value={formData.schoolName}
                          onChange={handleChange}
                          required
                        />
                      </div>

                      <div className="col-sm-6 mb-3">
                        <label htmlFor="currentGrade" className="form-label">
                          Current Grade <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control radius-8"
                          id="currentGrade"
                          name="currentGrade"
                          placeholder="Enter Current Grade"
                          value={formData.currentGrade}
                          onChange={handleChange}
                          required
                        />
                      </div>
                    </div>

                    <div className="d-flex justify-content-center gap-3 mt-8">
                      <button type="submit" className="btn btn-primary">
                        {studentData ? "Update" : "Register"}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* <div className="card h-100 p-8 radius-12">
                <div className="row justify-content-center">
                    <div className="col-xxl-12 col-xl-12 col-lg-12">
                        <div className="card border">
                            <div className="card-body ">
                                <form onSubmit={handleSubmit}>
                                    <div className="row">
                                        <div className="col-sm-6 mb-20">
                                            <label htmlFor="firstName" className="form-label">
                                                First Name <span className="text-danger">*</span>
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control radius-8"
                                                id="firstName"
                                                name="firstName"
                                                placeholder="Enter First Name"
                                                value={formData.firstName}
                                                onChange={handleChange}
                                                required
                                            />
                                        </div>

                                        <div className="col-sm-6 mb-20">
                                            <label htmlFor="lastName" className="form-label">
                                                Last Name <span className="text-danger">*</span>
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control radius-8"
                                                id="lastName"
                                                name="lastName"
                                                placeholder="Enter Last Name"
                                                value={formData.lastName}
                                                onChange={handleChange}
                                                required
                                            />
                                        </div>

                                        <div className="col-sm-6 mb-20">
                                            <label htmlFor="email" className="form-label">
                                                Email <span className="text-danger">*</span>
                                            </label>
                                            <input
                                                type="email"
                                                className="form-control radius-8"
                                                id="email"
                                                name="email"
                                                placeholder="Enter Email"
                                                value={formData.email}
                                                onChange={handleChange}
                                                required
                                                disabled={!!studentData}
                                            />
                                        </div>

                                        <div className="col-sm-6 mb-20">
                                            <label htmlFor="phone" className="form-label">
                                                Phone <span className="text-danger">*</span>
                                            </label>
                                            <input
                                                type="tel"
                                                className="form-control radius-8"
                                                id="phone"
                                                name="phone"
                                                placeholder="Enter Phone Number"
                                                value={formData.phone}
                                                onChange={handleChange}
                                                required
                                                disabled={!!studentData}
                                            />
                                        </div>

                                        <div className="col-sm-6 mb-20">
                                            <label htmlFor="schoolName" className="form-label">
                                                School Name <span className="text-danger">*</span>
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control radius-8"
                                                id="schoolName"
                                                name="schoolName"
                                                placeholder="Enter School Name"
                                                value={formData.schoolName}
                                                onChange={handleChange}
                                                required
                                            />
                                        </div>

                                        <div className="col-sm-6 mb-20">
                                            <label htmlFor="currentGrade" className="form-label">
                                                Current Grade <span className="text-danger">*</span>
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control radius-8"
                                                id="currentGrade"
                                                name="currentGrade"
                                                placeholder="Enter Current Grade"
                                                value={formData.currentGrade}
                                                onChange={handleChange}
                                                required
                                            />
                                        </div>
                                    </div>

                                    <div className="d-flex justify-content-end gap-3 mt-4">
                                      
                                        <button type="submit" className="btn btn-primary">
                                            {studentData ? "Update" : "Save"}
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div> */}
    </>
  );
};

export default RegisterStudent;

// import React, { useState, useEffect } from "react";
// import { useLocation, useNavigate } from "react-router-dom";
// import axios from "axios";
// import { toast, ToastContainer } from "react-toastify";
// import { baseUrl } from "../../helper/urls.js";
// import {
//     Box,
//     Grid,
//     TextField,
//     Button,
//     Typography,
//     Paper,
// } from "@mui/material";

// const RegisterStudent = () => {
//     const url = `${baseUrl}/api/students`;
//     const { token } = useSelector((state) => state.auth);
//     const location = useLocation();
//     const studentData = location.state?.student;
//     const navigate = useNavigate();

//     const [formData, setFormData] = useState({
//         firstName: "",
//         lastName: "",
//         email: "",
//         phone: "",
//         schoolName: "",
//         currentGrade: "",
//     });

//     useEffect(() => {
//         if (studentData) {
//             setFormData(studentData);
//         }
//     }, [studentData]);

//     const handleChange = (e) => {
//         const { name, value } = e.target;
//         setFormData((prevData) => ({
//             ...prevData,
//             [name]: value,
//         }));
//     };

//     const handleSubmit = async (e) => {
//         e.preventDefault();

//         const headers = {
//             "Content-Type": "application/json",
//             Accept: "application/json",
//             Authorization: `Bearer ${token}`,
//         };

//         try {
//             let response;

//             if (studentData?.id) {
//                 const updatePayload = { ...formData };
//                 response = await axios.put(`${url}/${studentData.id}`, updatePayload, {
//                     headers,
//                 });
//             } else {
//                 response = await axios.post(url, formData, { headers });
//             }

//             if (response.status === 200) {
//                 toast.success(response.data.data.message || "Student saved successfully!");
//                 navigate("/all-students");
//             }
//         } catch (error) {
//             if (error.response?.data?.errors) {
//                 error.response.data.errors.forEach((err) => toast.error(err.msg));
//             }
//             console.error("Error submitting student:", error);
//         }
//     };

//     return (
//         <>
//             <ToastContainer position="top-right" autoClose={3000} />
//             <Box p={4}>
//                 {/* <Paper elevation={3} sx={{ p: 4 }}> */}
//                     <Typography variant="h5" gutterBottom>
//                         {studentData ? "Update Student" : "Register Student"}
//                     </Typography>
//                     <Box component="form" onSubmit={handleSubmit} noValidate>
//                         <Grid container spacing={3}>
//                             <Grid item xs={12} sm={6}>
//                                 <TextField
//                                     fullWidth
//                                     label="First Name"
//                                     name="firstName"
//                                     value={formData.firstName}
//                                     onChange={handleChange}
//                                     required
//                                 />
//                             </Grid>
//                             <Grid item xs={12} sm={6}>
//                                 <TextField
//                                     fullWidth
//                                     label="Last Name"
//                                     name="lastName"
//                                     value={formData.lastName}
//                                     onChange={handleChange}
//                                     required
//                                 />
//                             </Grid>
//                             <Grid item xs={12} sm={6}>
//                                 <TextField
//                                     fullWidth
//                                     label="Email"
//                                     name="email"
//                                     value={formData.email}
//                                     onChange={handleChange}
//                                     required
//                                     disabled={!!studentData}
//                                 />
//                             </Grid>
//                             <Grid item xs={12} sm={6}>
//                                 <TextField
//                                     fullWidth
//                                     label="Phone"
//                                     name="phone"
//                                     value={formData.phone}
//                                     onChange={handleChange}
//                                     required
//                                     disabled={!!studentData}
//                                 />
//                             </Grid>
//                             <Grid item xs={12} sm={6}>
//                                 <TextField
//                                     fullWidth
//                                     label="School Name"
//                                     name="schoolName"
//                                     value={formData.schoolName}
//                                     onChange={handleChange}
//                                     required
//                                 />
//                             </Grid>
//                             <Grid item xs={12} sm={6}>
//                                 <TextField
//                                     fullWidth
//                                     label="Current Grade"
//                                     name="currentGrade"
//                                     value={formData.currentGrade}
//                                     onChange={handleChange}
//                                     required
//                                 />
//                             </Grid>
//                         </Grid>

//                         <Box mt={4} display="flex" justifyContent="flex-end" gap={2}>
//                             {/* <Button variant="outlined" color="error" onClick={() => navigate("/all-students")}>
//                                 Cancel
//                             </Button> */}
//                             <Button type="submit" variant="contained" color="primary">
//                                 {studentData ? "Update" : "Save"}
//                             </Button>
//                         </Box>
//                     </Box>
//                 {/* </Paper> */}
//             </Box>
//         </>
//     );
// };

// export default RegisterStudent;
